export default __webpack_public_path__ + "static/media/bar-partners.21ec984f.svg";